<template>
  <v-theme-provider :dark="dark">
    <div>
<!--      <base-img
        :src="require('@/assets/pe/logo.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />-->

      <base-title
        size="body-1"
        space="4"
        title="ПРОГРЕСС ИНЖИНИРИНГ"
        weight="regular"
      />

      <base-body>
        Лучшее исполнение. Высокое качество.
      </base-body>

      <base-btn
        class="mb-12"
        color="white"
        outlined
        @click="$router.push({ name: 'Manufacture' })"
      >
        Подробнее
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',
    props: {
      title: String,
      dark: Boolean,
    }
  }
</script>
